import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    language: 'en',
    translations: {
      MyPlan: { en: 'My Bundle', ar: 'إعدادات الباقة' },
      ActivePlan: { en: 'Active Bundle', ar: 'الباقة الحالية' },
      FuturePlan: { en: 'Future Bundle', ar: 'الباقة القادمة' },
      PlanPrice: { en: 'Price', ar: 'سعر الباقة' },
      AutoRenewIs: { en: 'Auto Renewal is ', ar: 'التجديد التلقائي ' },
      YouHaveNoPlanMsg: { en: 'You do not have an existing bundle', ar: 'لا توجد لديك باقة حالياً' },
      Enabled: { en: 'Enabled', ar: 'مفعل' },
      Disabled: { en: 'Disabled', ar: 'غير مفعل' },
      ChangeMyPlan: { en: 'Customize eeZee Flexi', ar: 'صمم eeZee Flexi' },
      CreateMyPlan: { en: 'Start eeZee Flexi', ar: 'ابدأ eeZee Flexi' },
      BackToMyPlan: { en: 'Back To My Bundle', ar: 'الرجوع إلي اعدادات الباقة' },
      CustomizePlan: { en: 'Customize Bundle', ar: 'تفصيل الباقة' },
      Bundles: { en: 'Bundles', ar: 'الباقات' },
      Internet: { en: 'Internet', ar: 'الإنترنت' },
      ZainToZain: { en: 'Zain-to-Zain Minutes', ar: 'دقائق ضمن شبكة زين' },
      LocalMinutes: { en: 'Local Minutes', ar: 'دقائق محلية' },
      InternationalMinutes: { en: 'International Minutes', ar: 'دقائق دولية' },
      AdditionalBenefits: { en: 'Additional Benefits', ar: 'مزايا إضافية' },
      Unlimited: { en: 'Unlimited', ar: 'غير محدود' },
      WhatsApp: { en: 'WhatsApp', ar: 'واتساب' },
      SocialMedia: { en: 'Social Media', ar: 'مواقع التواصل الاجتماعي' },
      YouTube: { en: 'YouTube', ar: 'يوتيوب' },
      BuyPlan: { en: 'Activate The Bundle', ar: 'تفعيل الباقة' },
      Next: { en: 'Next', ar: 'التالي' },
      Back: { en: 'Back', ar: 'رجوع' },
      Confirm: { en: 'Confirm', ar: 'تأكيد' },
      Confirmation: { en: 'Confirmation', ar: 'التأكيد' },
      ConfirmationMsg: {
        en: 'Confirm the activation of the selected bundle on your line ',
        ar: 'يرجى تأكيد تفعيل الباقة الجديدة على رقمك'
      },
      ChangeFuturePlan: { en: 'Change Future Bundle', ar: 'تغيير الباقة القادمة' },
      FuturePlanMsg: { en: 'The following bundle will be activated in', ar: 'الباقة القادمة سوف يتم تفعيلها بعد  ' },
      day: { en: 'day', ar: 'يوم' },
      days: { en: 'days', ar: 'أيام' },
      NoFutureOrderMsg: { en: 'You have no Future Bundle set', ar: 'لم يتم تصميم الباقة القادمة' },
      PlanDuration: { en: 'This bundle is valid for 30 days', ar: 'صلاحية الباقة 30 يوماً' },
      ByClicking: { en: 'By clicking the button, you confirm our ', ar: 'بالضغط على الزر أنت توافق على ' },
      Terms: { en: 'Terms & Conditions', ar: 'الشروط والأحكام' },
      PriceNotEnough1: {
        en: 'The minimum bundle price is KD ',
        ar: 'الحد الأدنى لسعر الباقة هو '
      },
      PriceNotEnough2: {
        en: '. Please adjust your selection to reach the minimum price.',
        ar: ' د.ك. يرجى تغيير المزايا المختارة للوصول الى الحد الأدنى للسعر'
      },
      SetFuturePlan: { en: 'Set Future Bundle', ar: 'تحديد الباقة القادمة' },
      CreatePlan: { en: 'Create a Bundle', ar: 'حدد الباقة' },
      PlanActivationSuccess: {
        en: 'The bundle has been activated successfully. This bundle is valid for 30 days.',
        ar: 'تم تفعيل الباقة بنجاح. هذه الباقة صالحة لـ 30 يوماً.'
      },
      PlanActivationSuccess1: {
        en: 'Maintain sufficient balance and renew your bundle automatically on time every month to enjoy the amazing and unmatched benefits for the same price:',
        ar: 'احتفظ برصيد كاف حتى تتجدد باقتك تلقائياً في الوقت المحدد كل شهر واستمتع بمزايا رائعة وحصرية بنفس السعر:'
      },
      PlanActivationSuccess2: {
        en: 'Carry over your unused GBs and Minutes this month to the next month.',
        ar: 'ترحيل سعة الانترنت والدقائق غير المستخدمة خلال هذا الشهر إلى الشهر القادم.'
      },
      PlanActivationSuccess3: {
        en: 'Double your GBs and Local Minutes benefits next month.',
        ar: 'ضاعف سعة الانترنت والدقائق المحلية في الشهر القادم.'
      },
      PlanActivationSuccess4: {
        en: 'Triple your GBs and Local Minutes benefits starting from the 3rd month onwards.',
        ar: 'احصل على 3 أضعاف سعات الانترنت والدقائق المحلية ابتداءً من الشهر الثالث.'
      },
      ThankYou: {
        en: 'Thank you.',
        ar: 'شكراً.'
      },
      PlanActivationSuccessFuture: {
        en: 'You Future Bundle was set successfully, it will be activated upon the expiry of your current bundle',
        ar: 'تم تحديد باقتك القادمة بنجاح. سيتم تفعيل باقتك القادمة بعد انتهاء صلاحية باقتك الحالية'
      },
      NoBalanceMessage1: {
        en: 'You have no sufficient balance to activate this bundle. Please recharge and try again.',
        ar: 'ليس لديك رصيد كافٍ لتفعيل الباقة. يرجى إعادة التعبئة والمحاولة مرة أخرى.'
      },
      NoBalanceMessage2: {
        en: 'Click on the following button to recharge.',
        ar: 'لإعادة التعبئة الآن اضغط على الزر أدناه'
      },
      RechargeNow: { en: 'Recharge Now', ar: 'أعد التعبئة الآن' },
      FailureMessage: {
        en: 'Sorry. An error occurred while processing your request. Please try again later. Thank you.',
        ar: 'نأسف. حدث خطأ أثناء تنفيذ طلبك. يرجى المحاولة لاحقاً. شكراً.'
      },
      OfferValidForMsg: { en: 'Offer valid until ', ar: 'الباقة صالحة حتى ' },
      FutureAutoRenewMsg: {
        en: 'To set a Future Bundle, the Auto Renewal feature should be ON. Do you like to switch it ON now?',
        ar: 'لتحديد باقتك القادمة، ينبغي تشغيل ميزة التجديد التلقائي. هل ترغب بالقيام بذلك الآن؟'
      },
      AutoRenewOffMsg: {
        en: 'Are you sure you want to turn Auto Renewal OFF?',
        ar: 'هل تريد إيقاف ميزة التجديد التلقائي؟'
      },
      AutoRenewOffFlexiMsg: {
        en: 'Please note that you will lose all Auto Renewal benefits',
        ar: 'يرجى العلم بأن جميع المزايا المتعلقة بالتجديد التلقائي سيتم إلغائها'
      },
      AutoRenewSuccessOn: { en: 'Auto Renew was activated successfully.', ar: 'تم تفعيل ميزة التجديد التلقائي بنجاح' },
      AutoRenewSuccessOff: {
        en: 'Auto Renew was deactivated successfully.',
        ar: 'تم تعطيل ميزة التجديد التلقائي بنجاح'
      },
      AutoRenewError: {
        en: 'Sorry. An error occurred while processing your request. Please try again later. Thank you.',
        ar: 'نأسف. حدث خطأ أثناء تنفيذ طلبك. يرجى المحاولة لاحقاً. شكراً.'
      },
      AutoRenewConfirm: {
        en: 'Your bundle will be renewed automatically upon expiry. Please confirm.',
        ar: 'سيتم تجديد باقتك تلقائيًا عند انتهاء صلاحيتها. يرجى التأكيد.'
      },
      SocialNetworks: {
        en: '(Facebook, Snapchat, Twitter, Instagram)',
        ar: '(Facebook, Snapchat, Twitter, Instagram)'
      },
      ActivateNowLater: {
        en: 'Would you like to activate the selected bundle NOW? Or set as your Future Bundle?',
        ar: 'هل ترغب في تفعيل الباقة الآن؟ أو تفضل تخصيصها كباقتك القادمة؟'
      },
      PlanExpireIn: { en: 'Your bundle will expire on ', ar: 'ستنتهي صلاحية باقتك في ' },
      ActivateNow: { en: 'Activate Now', ar: 'الآن' },
      PlanForLater: { en: 'Set as Future Bundle', ar: 'صمم كباقة قادمة' },
      PlanActivation: { en: 'Bundle Activation', ar: 'تفعيل الباقة' },
      SameOffer: { en: 'Same offer as current', ar: 'الباقة المختارة تطابق الباقة الحالية' },
      OK: { en: 'OK', ar: 'موافق' },
      Cancel: { en: 'Cancel', ar: 'إلغاء' },
      UL: { en: 'UL', ar: 'غير محدود' },
      SwapConfirmation: {
        en: 'You are about to change your existing bundle which will result in cancelling your current benefits along with any add-ons you might have purchased. Would you like to continue?',
        ar: 'انت على وشك تغيير باقتك الحالية مما سينتج عنه الغاء المزايا المتوفرة لديك حالياً بما في ذلك أية إضافات قد قمت بتفعيلها .هل ترغب بالاستمرار؟'
      },
      Yes: {
        en: 'Yes',
        ar: 'نعم'
      },
      LowTenure1: {
        en: 'Sorry, this service is available for numbers that have been active for 27 days on Zain network only. You can start using this service on ',
        ar: 'نأسف. هذه الخدمة متاحة للأرقام التي مضى عليها أكثر من 27 يوماً في شبكة زين. يمكنك استخدام هذه الخدمة ابتداءً من تاريخ '
      },
      LowTenure2: {
        en: 'To activate other bundles, please visit zBot:',
        ar: 'لتفعيل باقات أخرى، يرجى زيارة zBot'
      },
      LowTenure3: {
        en: 'http://zain.to/zbot',
        ar: 'http://zain.to/zbot'
      },
      January: { en: 'January', ar: 'يناير' },
      February: { en: 'February', ar: 'فبراير' },
      March: { en: 'March', ar: 'مارس' },
      April: { en: 'April', ar: 'أبريل' },
      May: { en: 'May', ar: 'مايو' },
      June: { en: 'June', ar: 'يونيو' },
      July: { en: 'July', ar: 'يوليو' },
      August: { en: 'August', ar: 'أغسطس' },
      September: { en: 'September', ar: 'سبتمبر' },
      October: { en: 'October', ar: 'اكتوبر' },
      November: { en: 'November', ar: 'نوفمبر' },
      December: { en: 'December', ar: 'ديسمبر' },
      DownloadApp: { en: 'Download App', ar: 'تحميل التطبيق' },
      PromoMsg: {
        en: 'Limited Time Offer!',
        ar: 'عرض لفترة محدودة!'
      },
      PromoMsg2: {
        en: 'Upgrade your plan to the best 5G Network in Kuwait starting from 8KD!',
        ar: 'ارتق بباقتك الى افضل شبكة 5G في الكويت ابتداء من 8 د.ك فقط!'
      },
      PromoFreebie: {
        en: '60GBs + 60 Local Minutes',
        ar: '60 GB مع 60 دقيقة محلية'
      },
      PromoValidForHours: {
        en: '(Valid for 24 hours)',
        ar: '(صالحة لمدة 24 ساعة)'
      },
      PromoValidForDays7: {
        en: '(Valid for 7 days)',
        ar: '(صالحة لمدة 7 أيام)'
      },
      PromoValidForDays14: {
        en: '(Valid for 14 days)',
        ar: '(صالحة لمدة 14 يوماً)'
      },
      PromoValidForDays21: {
        en: '(Valid for 21 days)',
        ar: '(صالحة لمدة 21 يوماً)'
      },
      PromoValidForDays30: {
        en: '(Valid for 30 days)',
        ar: '(صالحة لمدة 30 يوماً)'
      },
      Prepaid2020Msg: {
        en: 'Customize your bundle, activate and renew it automatically to get double the benefits on the second month and triple the benefits starting from the 3rd month for the same price!',
        ar: 'صمم باقتك، فعّلها، وقم بتجديدها تلقائياً لتحصل على ضعف المزايا في الشهر الثاني و3 أضعاف المزايا ابتداءً من الشهر الثالث بنفس السعر!'
      },
      StartNow: {
        en: 'Start Now',
        ar: 'ابدأ الآن'
      },
      Free30Days: {
        en: '(valid for 30 days and not auto-renewable)',
        ar: '(صالحة لمدة ٣٠ يوما ولا تتجدد تلقائيا)'
      },
      Free: {
        en: 'FREE',
        ar: 'مجانا'
      },
      Doubled: { en: 'Doubled! ', ar: 'مميزات مضاعفة!' },
      NoThanks: { en: 'No Thanks ', ar: 'نعم' },
      YesPlease: { en: 'Yes Please ', ar: 'لا' },
      Summary: {
        en: 'Summary',
        ar: 'الملخص'
      },
      MainPlanPrice: {
        en: 'Main Plan Price',
        ar: 'سعر الباقة الأساسية'
      },
      Total: {
        en: 'Total',
        ar: 'المجموع'
      },
      Extra: {
        en: 'Extra',
        ar: 'إضافي'
      },
      '5GService': {
        en: '5G Service',
        ar: '5G Service'
      },
      Active: {
        en: 'Active',
        ar: 'مفعّل'
      },
      FooterMessageBelow8KD: { en: 'Add XX KD to upgrade your plan to 5G! ', ar: 'أضف XX د.ك لترتق بباقتك الى 5G!' },
      FooterMessageAbove8KD: { en: 'Welcome the best 5G Network in Kuwait!', ar: 'أهلاً بك في أفضل شبكة 5G في الكويت!' },
      OfferBenefitMessageAbove8KD: {
        en: '100GB FREE Internet capacity (valid for 3 days)',
        ar: '100 GB سعة انترنت مجاناً (صالحة لمدة 3 أيام)'
      },
      ExtraOfferBenefit: {
        en: 'Additional 100GB FREE!',
        ar: 'سعة اضافية 100 GB مجاناً!'
      }
    },
    settings: {
      "DATA": [
        {
          "titleEn": "Local Internet",
          "titleAr": "الانترنت",
          "subTitleEn": "4G LTE",
          "subTitleAr": "4G LTE",
          "unitEn": "GB",
          "unitAr": "GB",
          "id": 1,
          "value": "0.0",
          "type": "DATA",
          "bucketUnit": "Volume",
          "price": "0",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Internet",
          "titleAr": "الانترنت",
          "subTitleEn": "4G LTE",
          "subTitleAr": "4G LTE",
          "unitEn": "GB",
          "unitAr": "GB",
          "id": 1,
          "value": "15.0",
          "type": "DATA",
          "bucketUnit": "Volume",
          "price": "2.5",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Internet",
          "titleAr": "الانترنت",
          "subTitleEn": "4G LTE",
          "subTitleAr": "4G LTE",
          "unitEn": "GB",
          "unitAr": "GB",
          "id": 1,
          "value": "30.0",
          "type": "DATA",
          "bucketUnit": "Volume",
          "price": "4",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Internet",
          "titleAr": "الانترنت",
          "subTitleEn": "4G LTE",
          "subTitleAr": "4G LTE",
          "unitEn": "GB",
          "unitAr": "GB",
          "id": 1,
          "value": "60.0",
          "type": "DATA",
          "bucketUnit": "Volume",
          "price": "5.5",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Internet",
          "titleAr": "الانترنت",
          "subTitleEn": "4G LTE",
          "subTitleAr": "4G LTE",
          "unitEn": "GB",
          "unitAr": "GB",
          "id": 1,
          "value": "90.0",
          "type": "DATA",
          "bucketUnit": "Volume",
          "price": "6",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Internet",
          "titleAr": "الانترنت",
          "subTitleEn": "4G LTE",
          "subTitleAr": "4G LTE",
          "unitEn": "GB",
          "unitAr": "GB",
          "id": 1,
          "value": "150.0",
          "type": "DATA",
          "bucketUnit": "Volume",
          "price": "7",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Internet",
          "titleAr": "الانترنت",
          "subTitleEn": "4G LTE",
          "subTitleAr": "4G LTE",
          "unitEn": "GB",
          "unitAr": "GB",
          "id": 1,
          "value": "250.0",
          "type": "DATA",
          "bucketUnit": "Volume",
          "price": "11",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Internet",
          "titleAr": "الانترنت",
          "subTitleEn": "4G LTE",
          "subTitleAr": "4G LTE",
          "unitEn": "GB",
          "unitAr": "GB",
          "id": 1,
          "value": "43200.0",
          "type": "DATA",
          "bucketUnit": "Volume",
          "price": "15",
          "isUnlimited": true,
          "isSelected": false
        }
      ],
      "ONNETMINUTES": [
        {
          "titleEn": "Zain to Zain",
          "titleAr": "دقائق ضمن شبكة زين",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 2,
          "value": "0.0",
          "type": "ON-NET MINUTES",
          "bucketUnit": "Time",
          "price": "0",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Zain to Zain",
          "titleAr": "دقائق ضمن شبكة زين",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 2,
          "value": "100.0",
          "type": "ON-NET MINUTES",
          "bucketUnit": "Time",
          "price": "0.5",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Zain to Zain",
          "titleAr": "دقائق ضمن شبكة زين",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 2,
          "value": "250.0",
          "type": "ON-NET MINUTES",
          "bucketUnit": "Time",
          "price": "1",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Zain to Zain",
          "titleAr": "دقائق ضمن شبكة زين",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 2,
          "value": "500.0",
          "type": "ON-NET MINUTES",
          "bucketUnit": "Time",
          "price": "1.5",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Zain to Zain",
          "titleAr": "دقائق ضمن شبكة زين",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 2,
          "value": "43200.0",
          "type": "ON-NET MINUTES",
          "bucketUnit": "Time",
          "price": "2",
          "isUnlimited": true,
          "isSelected": false
        }
      ],
      "LOCALMINUTES": [
        {
          "titleEn": "Local Minutes",
          "titleAr": "دقائق محلية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 3,
          "value": "0.0",
          "type": "LOCAL MINUTES",
          "bucketUnit": "Time",
          "price": "0",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Minutes",
          "titleAr": "دقائق محلية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 3,
          "value": "100.0",
          "type": "LOCAL MINUTES",
          "bucketUnit": "Time",
          "price": "1",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Minutes",
          "titleAr": "دقائق محلية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 3,
          "value": "250.0",
          "type": "LOCAL MINUTES",
          "bucketUnit": "Time",
          "price": "1.5",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Minutes",
          "titleAr": "دقائق محلية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 3,
          "value": "500.0",
          "type": "LOCAL MINUTES",
          "bucketUnit": "Time",
          "price": "2",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Minutes",
          "titleAr": "دقائق محلية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 3,
          "value": "1000.0",
          "type": "LOCAL MINUTES",
          "bucketUnit": "Time",
          "price": "3",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Local Minutes",
          "titleAr": "دقائق محلية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 3,
          "value": "9000.0",
          "type": "LOCAL MINUTES",
          "bucketUnit": "Time",
          "price": "6",
          "isUnlimited": true,
          "isSelected": false
        }
      ],
      "INTERNATIONALMINUTES": [
        {
          "titleEn": "International Minutes",
          "titleAr": "دقائق دولية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 4,
          "value": "0.0",
          "type": "INTERNATIONAL MINUTES",
          "bucketUnit": "Time",
          "price": "0",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "International Minutes",
          "titleAr": "دقائق دولية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 4,
          "value": "10.0",
          "type": "INTERNATIONAL MINUTES",
          "bucketUnit": "Time",
          "price": "1.5",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "International Minutes",
          "titleAr": "دقائق دولية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 4,
          "value": "30.0",
          "type": "INTERNATIONAL MINUTES",
          "bucketUnit": "Time",
          "price": "3",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "International Minutes",
          "titleAr": "دقائق دولية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 4,
          "value": "60.0",
          "type": "INTERNATIONAL MINUTES",
          "bucketUnit": "Time",
          "price": "5",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "International Minutes",
          "titleAr": "دقائق دولية",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "Min",
          "unitAr": "دقيقة",
          "id": 4,
          "value": "120.0",
          "type": "INTERNATIONAL MINUTES",
          "bucketUnit": "Time",
          "price": "8",
          "isUnlimited": false,
          "isSelected": false
        }
      ],
      "WHATSAPP": [
        {
          "titleEn": "WhatsApp",
          "titleAr": "واتساب",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "",
          "unitAr": "",
          "id": 5,
          "value": "0.0",
          "type": "WHATSAPP",
          "bucketUnit": "Events",
          "price": "0",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "WhatsApp",
          "titleAr": "واتساب",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "",
          "unitAr": "",
          "id": 5,
          "value": "1.0",
          "type": "WHATSAPP",
          "bucketUnit": "Events",
          "price": "1",
          "isUnlimited": true,
          "isSelected": false
        }
      ],
      "SOCIALMEDIA": [
        {
          "titleEn": "Social Media",
          "titleAr": "مواقع التواصل الاجتماعي",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "",
          "unitAr": "",
          "id": 6,
          "value": "0.0",
          "type": "SOCIAL MEDIA",
          "bucketUnit": "Events",
          "price": "0",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "Social Media",
          "titleAr": "مواقع التواصل الاجتماعي",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "",
          "unitAr": "",
          "id": 6,
          "value": "1.0",
          "type": "SOCIAL MEDIA",
          "bucketUnit": "Events",
          "price": "1",
          "isUnlimited": true,
          "isSelected": false
        }
      ],
      "YOUTUBE": [
        {
          "titleEn": "YouTube",
          "titleAr": "يوتيوب",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "",
          "unitAr": "",
          "id": 7,
          "value": "0.0",
          "type": "YOUTUBE",
          "bucketUnit": "Events",
          "price": "0",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "YouTube",
          "titleAr": "يوتيوب",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "",
          "unitAr": "",
          "id": 7,
          "value": "1.0",
          "type": "YOUTUBE",
          "bucketUnit": "Events",
          "price": "2",
          "isUnlimited": true,
          "isSelected": false
        }
      ],
      "5G": [
        {
          "titleEn": "5G Service",
          "titleAr": "5G Service",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "",
          "unitAr": "",
          "id": 8,
          "value": "0.0",
          "type": "5G",
          "bucketUnit": "Events",
          "price": "0",
          "isUnlimited": false,
          "isSelected": false
        },
        {
          "titleEn": "5G Service",
          "titleAr": "5G Service",
          "subTitleEn": "",
          "subTitleAr": "",
          "unitEn": "",
          "unitAr": "",
          "id": 8,
          "value": "1.0",
          "type": "5G",
          "bucketUnit": "Events",
          "price": "2",
          "isUnlimited": true,
          "isSelected": false
        }
      ]
    },
    futureSettings: {},
    msisdn: '',
    userInfo: {},
    token: '',
    settingFuture: false,
    isDirty: false,
    minimumPrice: 5,
    upsellOffersMessages: {
      'DATA': {
        en: 'Why not add 20 GB for KD 1 only?',
        ar: 'أضف 20 GB بـ 1 د.ك فقط'
      },
      'LOCAL MINUTES': {
        en: 'Why not add 200 Local Minutes for KD 1 only?',
        ar: 'أضف 200 دقيقة محلية بـ 1 د.ك فقط'
      },
      'SOCIAL MEDIA': {
        en: 'Why not add Unlimited Social Media for KD 1 only?',
        ar: 'أضف مواقع التواصل الاجتماعي غير محدود بـ 1 د.ك فقط'
      },
      'WHATSAPP': {
        en: 'Why not add Unlimited WhatsApp for KD 1 only?',
        ar: 'أضف واتساب غير محدود بـ 1 د.ك فقط'
      },
      'YOUTUBE': {
        en: 'Why not add Unlimited YouTube for KD 1 only?',
        ar: 'أضف يوتيوب غير محدود بـ 1 د.ك فقط'
      },
    },
    upsellOffers: {
      'DATA': {
        en: '20 GB Internet',
        ar: '20 GB انترنت'
      },
      'LOCAL MINUTES': {
        en: '200 Local Minutes',
        ar: '200 دقيقة محلية'
      },
      'SOCIAL MEDIA': {
        en: 'Unlimited Social Media',
        ar: 'مواقع التواصل الاجتماعي غير محدود'
      },
      'WHATSAPP': {
        en: 'Unlimited WhatsApp ',
        ar: 'واتساب غير محدود'
      },
      'YOUTUBE': {
        en: 'Unlimited YouTube',
        ar: 'يوتيوب غير محدود'
      },
    },
    is5GFeatureActive: false,
    whiteList5G: []
  },
  mutations: {
    getUserInfoSuccess(state, payload) {
      state.userInfo = payload
    },
    setToken(state, token) {
      state.token = token
    }
  },
  actions: {
    getPossibleSettings({ state }, hasPRAL8 = false) {
      return new Promise((resolve, reject) => {
        api.getPossibleSettings(state.token, hasPRAL8).then(res => {

          state.settings = res.data.settings
          state.futureSettings = res.data.futureSettings

          // state.settings.DATA.forEach(x => {
          //   if (!x.isUnlimited && x.value !== '0.0') {
          //     x.value = (parseFloat(x.value) * 2).toFixed(1)
          //   }
          // })
          //
          // state.settings.LOCALMINUTES.forEach(x => {
          //   if (!x.isUnlimited && x.value !== '0.0') {
          //     x.value = (parseFloat(x.value) * 2).toFixed(1)
          //   }
          // })
          //
          // state.settings.ONNETMINUTES.forEach(x => {
          //   if (!x.isUnlimited && x.value !== '0.0') {
          //     x.value = (parseFloat(x.value) * 2).toFixed(1)
          //   }
          // })

          resolve()
        }).catch(err => reject(err))
      })
    },
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.getUserInfo(state.token)
            .then(res => {
              if (res.data.msisdn) {
                if (state.whiteList5G.includes(res.data.msisdn)) {
                  state.is5GFeatureActive = true
                }
              }
              // console.log(res.data)
              commit('getUserInfoSuccess', res.data)
              resolve()
            }).catch(err => reject(err))
      })
    },
    async subscribe({ state }, subscribeData) {
      return api.subscribe(state.token, subscribeData)
    },
    async subscribeWithCode({ state }, code) {
      return api.subscribeWithCode(state.token, code)
    },
    async setAutoRenew({ state }, autoRenewData) {
      return api.setAutoRenew(state.token, autoRenewData)
    },
    async getUpsellSettings({ state }, subscribeData) {
      return api.getUpsellSettings(state.token, subscribeData)
    }
  },
  getters: {
    getTranslation: state => key => {
      if (typeof state.translations[key] === 'undefined') {
        console.log('No translation value found for: ' + key)
        return ''
      }
      return state.translations[key][state.language]
    },
    getDir: state => () => {
      return state.language === 'ar' ? 'rtl' : 'ltr'
    },
    getSettings: state => () => {
      if (!state.settingFuture) return state.settings
      else return state.futureSettings
    },
    getMinimumPrice: state => () => {
      if (!state.settingFuture) return 5
      else return 5
    },
  }
})

export default store
